import {Menu, Transition} from "@headlessui/react";
import {Fragment} from "react";

import {useDispatch, useSelector} from "react-redux";

import {Currency} from "../iconComponents/IcCurrency";
import EditIcon from "assets/icons/EditIcon";
import {formatPrice, getDefaultCurrency} from "helpers";
import {addOpenDrawer} from "store/actions/appAction";
import IcArrow from "../iconComponents/IcArrow";

export function CurrencyDropdown({name, role, version}) {
    const dispatch = useDispatch();

    const {businessCurrencies, lastUpdatedDate, currencies} = useSelector((state) => state).currencyReducer;

    const business = useSelector((state) => state).businessReducer?.business;

    const defaultCurrency = getDefaultCurrency(business?.business?.default_currency_id, currencies);
    return (
        <div className="text-right">
            <Menu as="div" className="relative inline-block text-left">
                <div>
                    <Menu.Button
                        className="inline-flex w-full justify-center rounded-md bg-white  px-4 py-2 text-sm font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                        <div className="flex flex-row items-center justify-center ">
                            <Currency/>
                            <div className="pr-1">
                                <IcArrow/>
                            </div>
                        </div>
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items
                        className="absolute left-2 mt-2 w-48 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className=" ">
                            <Menu.Item>
                                {({active}) => (
                                    <button
                                        className={
                                            "group  min-h-[70px] flex flex-row w-full items-center rounded-t-md px-2 py-2 text-sm bg-[#E9F2FF]  "
                                        }
                                    >
                                        <div className="flex flex-1 flex-col px-3 justify-between  ">
                                            <span className="text-sm text font-normal text-black text-right">نرخ تبدیل ارز ها</span>
                                            {lastUpdatedDate && (
                                                <span
                                                    className="text-xs text font-normal text-[#878787] text-right pt-1 ">
                          {`آخرین بروز رسانی : ${lastUpdatedDate.split("-").reverse().join("-")}`}
                        </span>
                                            )}
                                        </div>
                                    </button>
                                )}
                            </Menu.Item>
                        </div>
                        <div>
                            {
                                //@ts-ignore
                                businessCurrencies.map((item,key) => {
                                    //@ts-ignore
                                    const object = currencies.find((it) => it.id === item.id);
                                    return object ? (
                                        <Menu.Item key={key}>
                                            {({active}) => (
                                                <button
                                                    className={`${
                                                        active ? "bg-blue-100 text-gray-900" : "text-gray-900"
                                                    } group flex w-full items-center px-2  text-sm  bg-white`}
                                                >
                                                    <div
                                                        className="flex flex-1 py-3 flex-row-reverse px-3 items-center justify-between  ">
                            <span className="text-sm text font-normal text-[#6F6F6F] text-right">
                              {object.en_title} 1
                            </span>
                                                        <span
                                                            className="text-sm text font-normal text-[#6F6F6F] text-right"> = </span>
                                                        <span
                                                            className="text-sm text font-normal text-[#6F6F6F] text-right">
                              {formatPrice(item.currencyExchange)} {defaultCurrency.en_title}{" "}
                            </span>
                                                    </div>
                                                </button>
                                            )}
                                        </Menu.Item>
                                    ) : null;
                                })
                            }
                        </div>
                        <div>
                            <Menu.Item>
                                {({active}) => (
                                    <button
                                        className={
                                            "group flex flex-col w-full items-center rounded-b-md px-2 py-2 text-sm bg-white "
                                        }
                                        onClick={() => dispatch(addOpenDrawer(true, "currencyDrawer", "left"))}
                                    >
                                        <div className="flex flex-row items-center justify-center w-full">
                                            <EditIcon/>
                                            <span className="text-xs text font-normal text-blue-1 text-right">ویرایش نرخ ها</span>
                                        </div>
                                    </button>
                                )}
                            </Menu.Item>
                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    );
}
